"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(6, 2),
  gridTemplateColumns: 'repeat(2, 1fr)',
  maxWidth: 985,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(6, 3),
    gridTemplateColumns: 'repeat(3, 1fr)'
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(4, 1fr)'
  }
}));
